import { Component, OnInit } from '@angular/core';
import { CustomOktaAuthService } from '../auth/oktaauth.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(private authSvc: CustomOktaAuthService) { }

  ngOnInit() {
    this.authSvc.logout();
  }

}
